<template>
  <div class="merchant-container">
    <div class="side-nav">
      <MerchantSideNav />
      <MenuToggle />
    </div>
    <div class="merchant-body">
      <header>
        <MerchantHeader />
      </header>
      <div class="dashboard-content">
        <div class="row align-items-center justify-content-between m-0">
          <div class="col-12 col-xl-5 pl-0">
            <div class="row align-items-center">
              <h3 class="pl-3">Merchant Details</h3>
            </div>
          </div>
          <div class="col-12 col-xl-7 pl-0">
            <div class="row">
              <!-- KYC NOT verified -> merchant must submit / complete KYC -->
              <div class="col-12 col-xl-4 mb-2" v-if="!isKycVerified">
                <router-link :to="{ name: 'merchant-kyc' }">
                  <b-button variant="primary">{{ kycActionLabel }}</b-button>
                </router-link>
              </div>
              <!-- KYC verified -> changes only through an Admin request -->
              <div class="col-12 col-xl-4 mb-2" v-else>
                <router-link :to="{ name: 'merchant-kyc' }">
                  <b-button variant="primary">Request KYC Update</b-button>
                </router-link>
              </div>
              <div class="col-12 col-xl-4 mb-2">
                <b-button variant="primary" v-b-modal.modal-1
                  >Update Profile</b-button
                >
              </div>
              <div class="col-12 col-xl-4 mb-2">
                <b-button variant="primary" v-b-modal.modal-2
                  >Change Password</b-button
                >
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-lg-12 col-xl-5 pl-0 mb-2">
            <div class="card-style">
              <div class="row justify-content-center">
                <div class="profile">
                  <img v-if="author && author.image" :src="author.image" />
                </div>
              </div>
              <div class="row justify-content-center">
                <div class="col-12 text-center">
                  <h3>{{ displayName }}</h3>
                </div>
              </div>
              <div
                v-if="isKycVerified"
                class="row justify-content-center m-0" style="color: #00a800;">
                <span>Verified</span>
                <div class="verified"></div>
                <span class="material-icons" variant="green">
                  verified_user
                </span>
              </div>
              <div
                v-else
                class="row justify-content-center m-0" style="color: #e08b00;">
                <span>KYC Not Verified</span>
              </div>
              <div
                class="row justify-content-md-between justify-content-around"
              >
                <span class="pl-3">Request Date</span>
                <span class="pr-3" v-if="application.created_at">{{ formatDate(application.created_at) }}</span>
              </div>
              <div
                class="row justify-content-md-between justify-content-around"
              >
                <span class="pl-3">User Status</span>
                <span class="pr-3" v-if="application.status == 'pending'">Pending</span>
                <span class="pr-3" v-if="application.status == 'processing'">Processing</span>
                <span class="pr-3" v-if="application.status == 'accepted'">Accepted</span>
              </div>
              <div
                class="row justify-content-md-between justify-content-around"
              >
                <span class="pl-3">KYC Status</span>
                <span class="pr-3">{{ author.kyc_status || 'Not Submitted' }}</span>
              </div>
            </div>
          </div>
          <div class="col-12 col-lg-12 col-xl-7 pl-0">
            <div class="card-hidden">
              <div class="card-style">
                <!--
                  Source of these values depends on KYC state:
                  is_kyc_verified === false  ->  merchant.application
                  is_kyc_verified === true   ->  merchant.kyc
                -->
                <div class="grid-layout">
                  <div class="right-side">
                    <h5 v-for="(field, index) in displayFields" :key="'l' + index">{{ field.label }}</h5>
                  </div>
                  <div class="right-side">
                    <h6 v-for="(field, index) in displayFields" :key="'v' + index">{{ field.value || '-' }}</h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <footer>
      <MerchantFooter />
    </footer>

    <!-- Update Profile : company logo (author.image) -->
    <b-modal id="modal-1" centered size="xl" title="Update Profile">
      <div class="row mb-3 justify-content-center">
        <div class="col-12 col-lg-6 mb-3">
          <div class="card-style text-center">
            <label>
              <div class="profile">
                <div class="choose">
                  <input
                    type="file"
                    name="profile-image"
                    id="profile-image"
                    ref="userFile"
                    accept="image/png, image/jpeg"
                    @change="onLogoChange"
                  />
                  <img v-if="logoPreview || (author && author.image)" :src="logoPreview || author.image" />
                </div>
                <div class="label mt-2">
                  <label for="profile-image" id="label">Click to Change Company Logo</label>
                </div>
              </div>
            </label>
            <span style="color: red;" v-if="errors.logo">{{ errors.logo }}</span>
          </div>
        </div>
      </div>
      <template #modal-footer="{ cancel }">
        <b-button size="sm" variant="success" @click="updateCompanyLogo"> Update </b-button>
        <b-button size="sm" variant="danger" @click="cancel()">Cancel</b-button>
      </template>
    </b-modal>

    <!-- KYC form : only when is_kyc_verified === false -->
    <b-modal id="modal-kyc" centered size="xl" title="Update KYC Details">
      <div class="row mb-3 justify-content-center">
        <div class="col-12 col-lg-4 mb-4">
          <div class="card-style text-center">
            <label>
              <div class="profile">
                <div class="choose">
                  <input
                    type="file"
                    name="kyc-image"
                    id="kyc-image"
                    ref="kycFile"
                    accept="image/png, image/jpeg"
                    @change="onLogoChange"
                  />
                  <img v-if="logoPreview || (author && author.image)" :src="logoPreview || author.image" />
                </div>
                <div class="label mt-2">
                  <label for="kyc-image" id="label">Click to Change Company Logo</label>
                </div>
              </div>
            </label>
          </div>
        </div>
        <div class="col-12 col-lg-8">
          <div class="card-style">
            <div class="row">
              <div class="col-12 col-lg-6 position-relative mb-3">
                <b-form-input v-model="kycForm.business_name" placeholder="Business Name"></b-form-input>
                <span class="position-absolute">Business Name</span>
                <span style="color: red;" v-if="errors.business_name">{{ errors.business_name }}</span>
              </div>
              <div class="col-12 col-lg-6 position-relative mb-3">
                <b-form-select v-model="kycForm.business_type" :options="businessTypes"></b-form-select>
                <span class="position-absolute">Business Type</span>
                <span style="color: red;" v-if="errors.business_type">{{ errors.business_type }}</span>
              </div>
            </div>
            <div class="row">
              <div class="col-12 col-lg-6 position-relative mb-3">
                <b-form-input v-model="kycForm.registration_number" placeholder="Registration Number"></b-form-input>
                <span class="position-absolute">Registration Number</span>
                <span style="color: red;" v-if="errors.registration_number">{{ errors.registration_number }}</span>
              </div>
              <div class="col-12 col-lg-6 position-relative mb-3">
                <b-form-input v-model="kycForm.pan_number" placeholder="PAN / VAT / GST Number"></b-form-input>
                <span class="position-absolute">PAN Number</span>
                <span style="color: red;" v-if="errors.pan_number">{{ errors.pan_number }}</span>
              </div>
            </div>
            <div class="row">
              <div class="col-12 col-lg-12 position-relative mb-3">
                <b-form-input v-model="kycForm.business_address" placeholder="Business Address"></b-form-input>
                <span class="position-absolute">Business Address</span>
                <span style="color: red;" v-if="errors.business_address">{{ errors.business_address }}</span>
              </div>
            </div>
            <div class="row">
              <div class="col-12 col-lg-6 position-relative mb-3">
                <b-form-input v-model="kycForm.city" placeholder="City"></b-form-input>
                <span class="position-absolute">City</span>
                <span style="color: red;" v-if="errors.city">{{ errors.city }}</span>
              </div>
              <div class="col-12 col-lg-6 position-relative mb-3">
                <b-form-input v-model="kycForm.country" placeholder="Country"></b-form-input>
                <span class="position-absolute">Country</span>
                <span style="color: red;" v-if="errors.country">{{ errors.country }}</span>
              </div>
            </div>
            <div class="row">
              <div class="col-12 col-lg-6 position-relative mb-3">
                <b-form-input v-model="kycForm.contact_number" placeholder="ex: +61########"></b-form-input>
                <span class="position-absolute">Contact Number</span>
                <span style="color: red;" v-if="errors.contact_number">{{ errors.contact_number }}</span>
              </div>
            </div>

            <h5 class="mt-3">Bank Details</h5>
            <div class="row">
              <div class="col-12 col-lg-6 position-relative mb-3">
                <b-form-input v-model="kycForm.bank_name" placeholder="Bank Name"></b-form-input>
                <span class="position-absolute">Bank Name</span>
                <span style="color: red;" v-if="errors.bank_name">{{ errors.bank_name }}</span>
              </div>
              <div class="col-12 col-lg-6 position-relative mb-3">
                <b-form-input v-model="kycForm.bank_branch" placeholder="Branch Name"></b-form-input>
                <span class="position-absolute">Bank Branch</span>
                <span style="color: red;" v-if="errors.bank_branch">{{ errors.bank_branch }}</span>
              </div>
            </div>
            <div class="row">
              <div class="col-12 col-lg-6 position-relative mb-3">
                <b-form-input v-model="kycForm.bank_account_name" placeholder="Account Holder Name"></b-form-input>
                <span class="position-absolute">Bank Account Name</span>
                <span style="color: red;" v-if="errors.bank_account_name">{{ errors.bank_account_name }}</span>
              </div>
              <div class="col-12 col-lg-6 position-relative mb-3">
                <b-form-input v-model="kycForm.bank_account_number" placeholder="Account Number"></b-form-input>
                <span class="position-absolute">Bank Account Number</span>
                <span style="color: red;" v-if="errors.bank_account_number">{{ errors.bank_account_number }}</span>
              </div>
            </div>

            <h5 class="mt-3">Documents</h5>
            <div class="row">
              <div class="col-12 col-lg-4 position-relative mb-3">
                <input
                  type="file"
                  class="form-control"
                  ref="registration_certificate"
                  accept="image/png, image/jpeg, image/jpg, application/pdf"
                  @change="onKycFileChange($event, 'registration_certificate')"
                />
                <span class="position-absolute">Registration Certificate</span>
                <span style="color: red;" v-if="errors.registration_certificate">{{ errors.registration_certificate }}</span>
              </div>
              <div class="col-12 col-lg-4 position-relative mb-3">
                <input
                  type="file"
                  class="form-control"
                  ref="pan_certificate"
                  accept="image/png, image/jpeg, image/jpg, application/pdf"
                  @change="onKycFileChange($event, 'pan_certificate')"
                />
                <span class="position-absolute">PAN Certificate</span>
                <span style="color: red;" v-if="errors.pan_certificate">{{ errors.pan_certificate }}</span>
              </div>
              <div class="col-12 col-lg-4 position-relative mb-3">
                <input
                  type="file"
                  class="form-control"
                  ref="owner_id_document"
                  accept="image/png, image/jpeg, image/jpg, application/pdf"
                  @change="onKycFileChange($event, 'owner_id_document')"
                />
                <span class="position-absolute">Owner ID Document</span>
                <span style="color: red;" v-if="errors.owner_id_document">{{ errors.owner_id_document }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <template #modal-footer="{ cancel }">
        <b-button size="sm" variant="success" @click="submitKyc"> Submit KYC </b-button>
        <b-button size="sm" variant="danger" @click="cancel()">Cancel</b-button>
      </template>
    </b-modal>

    <!-- Request KYC update from Admin : only when is_kyc_verified === true -->


    <!-- One step. /v1/users/changepassword takes old, new and confirm together; there is
         no OTP endpoint, so the second modal could never have completed. -->
    <b-modal id="modal-2" centered size="lg" title="Change Password">
      <div class="row mb-3">
        <div class="col-12">
          <div class="card-style">
            <div class="mb-3">Enter your current password, then choose a new one.</div>
            <div class="row">
              <div class="col-12 position-relative mb-3">
                <b-form-input v-model="old_password" type="password" autocomplete="current-password"></b-form-input>
                <span class="position-absolute">Current Password</span>
                <span style="color: red;" v-if="errors.old_password">{{errors.old_password}}</span>
              </div>
            </div>
            <div class="row">
              <div class="col-12 position-relative mb-3">
                <b-form-input v-model="new_password" type="password" autocomplete="new-password"></b-form-input>
                <span class="position-absolute">New Password</span>
                <span style="color: red;" v-if="errors.new_password">{{errors.new_password}}</span>
              </div>
            </div>
            <div class="row">
              <div class="col-12 position-relative">
                <b-form-input v-model="confirm_password" type="password" autocomplete="new-password"></b-form-input>
                <span class="position-absolute">Confirm New Password</span>
                <span style="color: red;" v-if="errors.confirm_password">{{errors.confirm_password}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <template #modal-footer="{ cancel }">
        <b-button size="sm" variant="success" :disabled="isChangingPassword" @click="changePassword">
          {{ isChangingPassword ? "Changing..." : "Change Password" }}
        </b-button>
        <b-button size="sm" variant="danger" @click="cancel()">Cancel</b-button>
      </template>
    </b-modal>

    <b-toast
      id="success-toast"
      variant="success"
      solid
      append-toast
      toaster="b-toaster-bottom-full"
    >
      <div slot="toast-title" class="d-flex flex-grow-1 align-items-baseline">
        <strong class="mr-auto">Success</strong>
      </div>
      <div>
        <p v-if="success != ''">{{success}}</p>
      </div>
    </b-toast>
    <b-toast
      id="error-toast"
      variant="warning"
      solid
      append-toast
      toaster="b-toaster-bottom-full"
    >
      <div slot="toast-title" class="d-flex flex-grow-1 align-items-baseline">
        <strong class="mr-auto">Error</strong>
      </div>
      <div>
        <p>{{ message }}</p>
      </div>
    </b-toast>

  </div>
</template>
<script>
import MerchantHeader from "./MerchantHeader.vue";
import MerchantFooter from "./MerchantFooter.vue";
import MerchantSideNav from "./MerchantSideNav.vue";
import MenuToggle from "./MenuToggle.vue";
import { mapActions, mapState } from "vuex";

export default {
  components: {
    MerchantHeader,
    MerchantFooter,
    MerchantSideNav,
    MenuToggle,
  },
  data() {
    return {
      old_password: "",
      isChangingPassword: false,
      new_password: "",
      confirm_password: "",
      success: "",
      errors: {},
      logoFile: null,
      logoPreview: "",
      kycForm: {
        business_name: "",
        business_type: "",
        registration_number: "",
        pan_number: "",
        business_address: "",
        city: "",
        country: "",
        contact_number: "",
        bank_name: "",
        bank_branch: "",
        bank_account_name: "",
        bank_account_number: "",
      },
      // POST merchant/kyc requires these three documents (multipart)
      kycFiles: {
        registration_certificate: null,
        pan_certificate: null,
        owner_id_document: null,
      },
      businessTypes: [
        { value: "", text: "Select Business Type" },
        { value: "private_limited", text: "Private Limited" },
        { value: "public_limited", text: "Public Limited" },
        { value: "sole_proprietorship", text: "Sole Proprietorship" },
        { value: "partnership", text: "Partnership" },
      ],
      valid_email:/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
      valid_url: /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/,
      valid_phonoe: /^\+(?:[0-9] ?){6,14}[0-9]$/,
      valid_password: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\s).{8,24}$/,
    };
  },
  computed: {
    ...mapState([
      "successmessage",
      "errormessage",
      "message",
      "profile",
      "merchants",
      "countries"
    ]),
    author: function () {
      return (this.profile && this.profile.author) ? this.profile.author : {};
    },
    merchant: function () {
      return this.author.merchant ? this.author.merchant : {};
    },
    // Source when KYC is NOT verified
    application: function () {
      return this.merchant.application ? this.merchant.application : {};
    },
    // Source when KYC IS verified
    kycInfo: function () {
      return this.merchant.kyc ? this.merchant.kyc : {};
    },
    isKycVerified: function () {
      return this.author.is_kyc_verified === true;
    },
    kycStatusValue: function () {
      return this.kycInfo.status || this.author.kyc_status || "";
    },
    // not_submitted -> complete it | pending -> still editable until verified
    kycActionLabel: function () {
      const s = this.kycStatusValue;
      return (["pending", "submitted", "rejected"].indexOf(s) !== -1) ? "Update KYC Details" : "Complete KYC";
    },
    displayName: function () {
      return this.isKycVerified
        ? (this.kycInfo.business_name || this.application.company_name || this.author.full_name)
        : (this.application.company_name || this.author.full_name);
    },
    /**
     * Requirement #1
     * is_kyc_verified === false -> details come from merchant.application
     * is_kyc_verified === true  -> details come from merchant.kyc
     */
    displayFields: function () {
      if (this.isKycVerified) {
        const k = this.kycInfo;
        return [
          { label: "Merchant Code", value: k.merchant_code },
          { label: "Business Name", value: k.business_name },
          { label: "Business Type", value: this.formatBusinessType(k.business_type) },
          { label: "Registration Number", value: k.registration_number },
          { label: "PAN Number", value: k.pan_number },
          { label: "Business Address", value: k.business_address },
          { label: "City", value: k.city },
          { label: "Country", value: k.country },
          { label: "Contact Number", value: k.contact_number },
          { label: "KYC Status", value: k.status },
        ];
      }
      const a = this.application;
      return [
        { label: "Organization Name", value: a.company_name },
        { label: "Owner Name", value: a.owner_full_name },
        { label: "Business Phone Number", value: this.joinPhone(a.business_phone_country_code, a.business_phone_number) },
        { label: "Business Email", value: a.business_email },
        { label: "Site URL", value: a.website_url },
        { label: "Business Registration Number", value: a.registration_number },
        { label: "GST/VAT/PAN", value: a.tax_number },
        { label: "Address", value: this.joinAddress(a) },
        { label: "Contact Person", value: a.contact_person_name },
        { label: "Contact Number", value: this.joinPhone(a.contact_person_country_code, a.contact_person_number) },
        { label: "Contact Email", value: a.contact_person_email },
      ];
    },
  },
  created() {
    this.listProfile();
    this.listAllMerchants();
    this.listCountries();
  },
  watch: {
    // Pre-fill the KYC form once the profile arrives
    profile: {
      handler: function () {
        this.prefillKycForm();
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions([
      "listProfile",
      "listAllMerchants",
      "listCountries",
      "createKyc",
      "updateProfile",
    ]),
    joinPhone(code, number) {
      if (!number) { return ""; }
      return code ? "+" + code + " " + number : number;
    },
    joinAddress(a) {
      const parts = [a.company_address, a.city, a.state, a.zip_code, a.country];
      return parts.filter(function (p) { return p; }).join(", ");
    },
    formatBusinessType(value) {
      if (!value) { return ""; }
      return String(value)
        .split("_")
        .map(function (w) { return w.charAt(0).toUpperCase() + w.slice(1); })
        .join(" ");
    },
    prefillKycForm() {
      const k = this.kycInfo;
      const a = this.application;
      this.kycForm.business_name = k.business_name || a.company_name || "";
      this.kycForm.business_type = k.business_type || "";
      this.kycForm.registration_number = k.registration_number || a.registration_number || "";
      this.kycForm.pan_number = k.pan_number || a.tax_number || "";
      this.kycForm.business_address = k.business_address || a.company_address || "";
      this.kycForm.city = k.city || a.city || "";
      this.kycForm.country = k.country || a.country || "";
      this.kycForm.contact_number = k.contact_number || a.contact_person_number || "";
    },
    onKycFileChange(e, field) {
      const file = e.target.files && e.target.files[0];
      if (!file) { return; }
      const allowed = ["image/png", "image/jpeg", "image/jpg", "application/pdf"];
      if (allowed.indexOf(file.type) === -1) {
        this.kycFiles[field] = null;
        e.target.value = "";
        this.$set(this.errors, field, "Please upload a JPG, PNG or PDF file.");
        return;
      }
      this.kycFiles[field] = file;
      this.$set(this.errors, field, "");
    },
    onLogoChange(e) {
      const file = e.target.files && e.target.files[0];
      if (!file) { return; }
      this.logoFile = file;
      this.logoPreview = URL.createObjectURL(file);
    },
    // Update the company logo (author.image)
    updateCompanyLogo() {
      this.errors = {};
      if (!this.logoFile) {
        this.$set(this.errors, "logo", "Please choose an image first.");
        return;
      }
      const formData = new FormData();
      formData.append("image", this.logoFile);
      this.$store.dispatch("updateProfile", formData).then(() => {
        if (this.successmessage == "success") {
          this.success = "Company Logo Updated Successfully.";
          this.$bvModal.hide("modal-1");
          this.$bvToast.show("success-toast");
          this.logoFile = null;
          this.listProfile();
        } else if (this.errormessage == "errormessage") {
          this.$bvToast.show("error-toast");
        }
      });
    },
    /**
     * Requirement #2 (a): KYC not verified -> create / submit KYC.
     * The company logo is sent along with the KYC details.
     */
    submitKyc() {
      this.errors = {};
      const f = this.kycForm;
      if (!f.business_name) {
        this.$set(this.errors, "business_name", "Business Name Required.");
      } else if (!f.business_type) {
        this.$set(this.errors, "business_type", "Business Type Required.");
      } else if (!f.registration_number) {
        this.$set(this.errors, "registration_number", "Registration Number Required.");
      } else if (!f.pan_number) {
        this.$set(this.errors, "pan_number", "PAN Number Required.");
      } else if (!f.business_address) {
        this.$set(this.errors, "business_address", "Business Address Required.");
      } else if (!f.city) {
        this.$set(this.errors, "city", "City Required.");
      } else if (!f.country) {
        this.$set(this.errors, "country", "Country Required.");
      } else if (!f.contact_number) {
        this.$set(this.errors, "contact_number", "Contact Number Required.");
      } else if (!f.bank_name) {
        this.$set(this.errors, "bank_name", "Bank Name Required.");
      } else if (!f.bank_branch) {
        this.$set(this.errors, "bank_branch", "Bank Branch Required.");
      } else if (!f.bank_account_name) {
        this.$set(this.errors, "bank_account_name", "Bank Account Name Required.");
      } else if (!f.bank_account_number) {
        this.$set(this.errors, "bank_account_number", "Bank Account Number Required.");
      } else if (!this.kycFiles.registration_certificate) {
        this.$set(this.errors, "registration_certificate", "Registration Certificate Required.");
      } else if (!this.kycFiles.pan_certificate) {
        this.$set(this.errors, "pan_certificate", "PAN Certificate Required.");
      } else if (!this.kycFiles.owner_id_document) {
        this.$set(this.errors, "owner_id_document", "Owner ID Document Required.");
      } else {
        const formData = new FormData();
        Object.keys(f).forEach(function (key) {
          formData.append(key, f[key]);
        });
        const files = this.kycFiles;
        Object.keys(files).forEach(function (key) {
          if (files[key]) { formData.append(key, files[key]); }
        });
        if (this.logoFile) {
          formData.append("image", this.logoFile);
        }
        this.$store.dispatch("createKyc", formData).then(() => {
          if (this.successmessage == "success") {
            this.success = "KYC Details Submitted Successfully.";
            this.$bvModal.hide("modal-kyc");
            this.$bvToast.show("success-toast");
            this.listProfile();
          } else if (this.errormessage == "errormessage") {
            this.$bvToast.show("error-toast");
          }
        });
      }
    },
    /**
     * Requirement #2 (b): KYC verified -> details are read-only,
     * the merchant must ask the Admin to change them.
     */
    changePassword(){
      this.errors = {};
      if (this.old_password === "") {
        this.$set(this.errors, "old_password", "Current Password required.");
      } else if (this.new_password === "") {
        this.$set(this.errors, "new_password", "New Password required.");
      } else if (!this.valid_password.test(this.new_password)) {
        this.$set(this.errors, "new_password",
          "Password must contain 8 to 24 characters with a capital & small letter, number & special character.");
      } else if (this.new_password === this.old_password) {
        this.$set(this.errors, "new_password", "The new password must be different from the current one.");
      } else if (this.confirm_password !== this.new_password) {
        this.$set(this.errors, "confirm_password", "Confirm Passwords does not matched.");
      } else {
        this.isChangingPassword = true;
        const vm = this;
        this.$store.dispatch("changepassword", {
          old_password: this.old_password,
          new_password: this.new_password,
          confirm_password: this.confirm_password
        }).then(function (res) {
          vm.isChangingPassword = false;
          if (res && res.ok) {
            vm.old_password = "";
            vm.new_password = "";
            vm.confirm_password = "";
            vm.$bvModal.hide("modal-2");
            vm.success = res.message || "Password Change Successfully.";
            vm.$bvToast.show("success-toast");
            return;
          }
          // Field-level complaints belong under their field.
          const fe = (res && res.fieldErrors) || {};
          Object.keys(fe).forEach(function (k) { vm.$set(vm.errors, k, fe[k]); });
          vm.$bvToast.show("error-toast");
        }).catch(function () {
          vm.isChangingPassword = false;
          vm.$bvToast.show("error-toast");
        });
      }
    },
    formatDate(date) {
      return new Date(date).toLocaleDateString('en-GB', {
        day: 'numeric',
        month: 'long',
        year: 'numeric'
      });
    },
  }
};
</script>
<style lang="scss" scoped>
</style>
